import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ExtensionIcon from '@mui/icons-material/Extension';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { getPageSubtitle } from '../../constants/pageSubtitles';
import { PageHeader } from '../../components/ui/PageHeader';
import { brandColors, RADIUS } from '../../theme/appTheme';

export const IntegrationsPage: React.FC = () => (
  <Box>
    <PageHeader title="Integrations" subtitle={getPageSubtitle('platform_integrations')} icon={<ExtensionIcon />} />

    <Paper
      sx={{
        p: { xs: 4, md: 6 },
        borderRadius: `${RADIUS}px`,
        border: `1px solid ${brandColors.border}`,
        textAlign: 'center',
        maxWidth: 640,
        mx: 'auto',
        mt: 2,
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          mx: 'auto',
          mb: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: brandColors.green50,
          color: brandColors.primary,
        }}
      >
        <ScheduleIcon sx={{ fontSize: 36 }} />
      </Box>

      <Typography variant="h6" fontWeight={800} gutterBottom>
        Integrations table — coming in the next phase
      </Typography>

      <Typography color="text.secondary" sx={{ maxWidth: 480, mx: 'auto', lineHeight: 1.7 }}>
        The integrations marketplace and tenant allow-list table will be available in the next release.
        You will be able to manage third-party apps, featured integrations, and per-tenant access from here.
      </Typography>
    </Paper>
  </Box>
);
